// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const deferDispatch = require('client-v2/common/state/dispatch')
const ConnectAuthModalActions = require('client-v2/common/containers/auth-modal/actions-component')
const searchFormActions = require('client-v2/common/containers/search-form/actions')
const searchFormSelectors = require('client-v2/common/containers/search-form/selectors')
// Container imports
const LandingHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    ...ConnectAuthModalActions.mapStateToProps(state),
    isSearchVisible: searchFormSelectors.isVisible(state)
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...ConnectAuthModalActions.mapDispatchToProps(dispatch),
    onSearchToggle: dispatchAction(searchFormActions.show)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  LandingHeader
)
